import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip, IconButton } from "@mui/material";
import { Upload } from "@mui/icons-material";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { fetchVendorPO } from "../Service/ApiService";

const VendorPOController = () => {
  const vendordetails = JSON.parse(localStorage.getItem("vendor"));
  const vendorCode = vendordetails ? vendordetails.vendorCode : null;

  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [expand, setExpand] = useState(false);

  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 100 });
  const [rowCount, setRowCount] = useState(0);

  const [poNumber, setPONumber] = useState("");
  const [fromDate, setFromDate] = useState(localStorage.getItem("fromDate") || "");
  const [toDate, setToDate] = useState(localStorage.getItem("toDate") || "");

  useEffect(() => {
    console.log("Fetching PO:", paginationModel);
    getVendorPO();
  }, [paginationModel, poNumber, fromDate, toDate]);

  // useEffect(() => {
  //   localStorage.setItem("poNumber", poNumber);
  // }, [poNumber]);

  useEffect(() => {
    localStorage.setItem("fromDate", fromDate);
  }, [fromDate]);

  useEffect(() => {
    localStorage.setItem("toDate", toDate);
  }, [toDate]);

  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const { showAlert } = useAlert();

  // Filtered rows
  // const filteredRows = rows.filter((row) => {
  //   const poMatch = poNumber ? row.purchase_order_no.includes(poNumber) : true;

  //   const rowDate = new Date(row.po_date);
  //   const from = fromDate ? new Date(fromDate) : null;
  //   const to = toDate ? new Date(toDate) : null;

  //   const dateMatch = (!from || rowDate >= from) && (!to || rowDate <= to);

  //   return poMatch && dateMatch;
  // });

  // Base columns
  const baseColumns = [
    {
      field: "purchase_order_no",
      headerName: "PO No.",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "po_date",
      headerName: "PO Date",
      flex: 1,
      align: "center",
      headerAlign: "center",
      type: "date",
    },
    {
      field: "order_quantity",
      headerName: "Order Quantity",
      flex: 1,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
  ];

  // Upload column
  const uploadColumn = [
    {
      field: "upload_stock",
      headerName: "ASN Upload",
      flex: 1,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const PONumber = params.row.purchase_order_no;
        return (
          <Tooltip title="ASN Upload">
            <IconButton
              size="small"
              color="info"
              onClick={() => navigate("/asn-upload", { state: { PONumber } })}
            >
              <Upload fontSize="medium" />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  // Expanded columns (hidden by default)
  const expandedColumns = [
    {
      field: "material_code",
      headerName: "Material Code",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "material_description",
      headerName: "Material Description",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "quantity_received",
      headerName: "Quantity Received",
      flex: 1,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "balance_quantity",
      headerName: "Balance Quantity",
      flex: 1,
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "purchase_requisition",
      headerName: "Purchase Requisition",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "requester",
      headerName: "Requestor",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
    // Add more hidden columns here if needed
  ];

  // Fetch Vendor PO
  const getVendorPO = async () => {
    try {
      setLoading(true);
      const response = await fetchVendorPO(
        vendorCode,
        poNumber,
        fromDate,
        toDate,
        paginationModel.page + 1,
        paginationModel.pageSize
      );

      if (response && response.status === "success") {
        const converted = (response.data || []).map((item) => ({
          ...item,
          po_date_raw: item.po_date, // keep original for display
          po_date: new Date(item.po_date), // convert to Date object
        }));

        setRows(response.data || []);
        setRowCount(response.totalRows || 0);
      } else {
        showAlert("Something went wrong while showing PO data!");
        setRows([]);
        setRowCount(0);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      showAlert("Something went wrong while showing PO data!");
      setRows([]);
      setRowCount(0);
    }
  };

  // Expand / collapse columns
  const toggleExpand = () => {
    const newExpand = !expand;
    setExpand(newExpand);

    if (newExpand) {
      setColumns([...baseColumns, ...expandedColumns, ...uploadColumn]);
    } else {
      setColumns([...baseColumns, ...uploadColumn]);
    }
  };

  useEffect(() => setColumns([...baseColumns, ...uploadColumn]), []);

  return {
    columns,
    expand,
    toggleExpand,
    paginationModel,
    setPaginationModel,
    rowCount,
    poNumber,
    toDate,
    fromDate,
    setPONumber,
    setToDate,
    setFromDate,
    rows,
  };
};

export default VendorPOController;
